import * as z from "zod/v4";

export const getCheckoutOptimizationAnalyticsAssumptions = {
  name: "getCheckoutOptimizationAnalyticsAssumptions" as const,
  input: z.null(),
  output: z.object({ annualOrders: z.number().optional() }),
};
